import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import ArrowDownIcon from "../../../icons/ArrowDown";
import { LANGUAGE_FLAGS } from "../../../pages/Account/icons/Flags";
import { Language, LANGUAGES, toLanguage } from "../../../services/i18ln/languages";
import { Container } from "./styles";

const languages = LANGUAGES.map(language => ({ ...language, Flag: LANGUAGE_FLAGS[language.code] }));

export const AuthLanguageSelector = () => {
  const { t, i18n } = useTranslation();
  const containerRef = useRef<HTMLDivElement>(null);
  const [isOpen, setIsOpen] = useState(false);

  const currentLanguage = toLanguage(i18n.language);
  const currentItem = languages.find(language => language.code === currentLanguage) || languages[0];

  const changeLanguage = (language: Language) => {
    setIsOpen(false);

    if (language !== currentLanguage) {
      i18n.changeLanguage(language);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <Container ref={containerRef}>
      <button
        aria-expanded={isOpen}
        aria-label={t("components.languageSelector.label")}
        className="language-trigger"
        onClick={() => setIsOpen(isOpen => !isOpen)}
        type="button">
        <currentItem.Flag />
        <ArrowDownIcon
          width={14}
          height={14}
          color="#5E6272"
          className={`duration-300 ${isOpen ? "rotate-180" : "rotate-0"}`}
        />
      </button>
      {isOpen && (
        <div className="language-menu">
          {languages.map(({ label, code: value, Flag }) => (
            <button
              aria-pressed={value === currentLanguage}
              className={value === currentLanguage ? "active" : ""}
              key={value}
              onClick={() => changeLanguage(value)}
              type="button">
              <Flag />
              <span>{label}</span>
            </button>
          ))}
        </div>
      )}
    </Container>
  );
};
